import request from '@/api/request.js';
const baseURL = process.env.VUE_APP_BASE_COURSE_URL;

/**
 * 获取话术表单
 * @param {*} data.type outline 大纲 courseOverview 课程概述 outlineHandout 讲义 question 试卷
 * @returns
 */
export const getAigc = (data) => {
	return request({
    baseURL,
		url: `/api/mjkj-chat/chat/open/tool/getAigc`,
		method: 'post',
		data,
	})
}
/**
 * 获取回话ID
 * @param {*} data
 * @returns
 */
export const getChatListId = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/getChatListId`,
		method: 'post',
		data,
	})
}
/**
 * 获取课程列表
 * @param {*} data
 * @returns
 */
export const getCourseList = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/list`,
		method: 'post',
		data,
	})
}
/**
 * 创建课程
 * @param {*} data
 * @returns
 */
export const createCourse = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/create`,
		method: 'post',
		data,
	})
}
/**
 * 创建/修改大纲
 * @param {*} data
 * @returns
 */
export const createOutline = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/outline/create`,
		method: 'post',
		data,
	})
}
/**
 * 单个修改大纲
 * @param {*} data
 * @returns
 */
export const updateOutline = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/outline/update`,
		method: 'post',
		data,
	})
}
/**
 * 单个修改大纲
 * @param {*} data
 * @returns
 */
export const deleteOutline = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/outline/delete`,
		method: 'post',
		data,
	})
}
/**
 * 根据课程id获取大纲
 * @param {*} data courseId 课程id
 * @returns
 */
export const getCourseOutline = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/outline/get`,
		method: 'post',
		data,
	})
}

/**
 * 创建课程概述
 * @param {*} data courseId 课程id
 * @param {*} data content 概述内容
 * @returns
 */
export const createOverview = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse//course/overview/create`,
		method: 'post',
		data,
	})
}
/**
 * 课程详情
 * @param {*} data courseId 课程id
 * @returns
 */
export const getCourseDetail = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/get`,
		method: 'post',
		data,
	})
}

/**
 * 课程概述 试卷 讲义 预览详情
 * @param {*} data userFileId 文件id
 * @returns
 */
export const previewFile = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/filetransfer/preview`,
		method: 'get',
		params: data,
	})
}

/**
 * 课程概述 试卷 讲义 预览详情
 * @param {*} data userFileId 文件id
 * @returns
 */
export const detailFile = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/file/detail`,
		method: 'get',
		params: data,
	})
}

/**
 * 课程概述 试卷 讲义 预览详情
 * @param {*} data userFileId 文件id
 * @returns
 */
export const updateFile = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/file/update`,
		method: 'post',
		data,
	})
}

/**
 * 创建课程试卷
 * @param {*} data courseId 课程id
 * @param {*} data content 概述内容
 * @param {*} data questionId 试卷id
 * @returns
 */
export const createQuestion = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/question/create/content`,
		method: 'post',
		data,
	})
}

/**
 * 创建大纲讲义
 * @param {*} data outlineId 大纲id
 * @param {*} data content 概述内容
 * @returns
 */
export const createHandout = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/handout/create`,
		method: 'post',
		data,
	})
}

/**
 * 创建课程教材
 * @param {*} data outlineId 大纲id
 * @param {*} data content 概述内容
 * @returns
 */
export const createBooktext = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/booktext/create`,
		method: 'post',
		data,
	})
}

/**
 * 创建ppt大纲
 * @param {*} data content 概述内容
 * @returns
 */
export const createPPTOutline = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/kdxf/ppt/createOutline`,
		method: 'post',
		data: data,
	})
}
/**
 * 创建ppt大纲
 * @param {*} data content 概述内容
 * @returns
 */
export const createOutlineByDoc = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/kdxf/ppt/createOutlineByDoc`,
		method: 'post',
		data: data,
	}, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

/**
 * 获取ppt主题列表
 * @param {*} data.style 风格类型
 * @param {*} data.color 颜色类型
 * @param {*} data.industry 行业类型
 * @param {*} data.pageNum 页码
 * @param {*} data.pageSize 页码
 * @returns
 */
export const getPptThemelist = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/kdxf/ppt/themelist`,
		method: 'post',
		data,
	})
}
/**
 * 生成ppt
 * @param {*} data.outline Object
 * @param {*} data.query
 * @param {*} data.outlineSid
 * @param {*} data.templateId 模板id
 * @returns
 */
export const createppt = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/kdxf/ppt/createppt`,
		method: 'post',
		data,
	})
}
/**
 * 生成ppt
 * @param {*} data.sid
 * @returns
 */
export const queryPptProgressApi = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/kdxf/ppt/progress`,
		method: 'get',
		params: data,
	})
}
/**
 * 保存ppt
 * @param {*} formData
 * @returns
 */
export const savePPTAPi = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/ppt/save`,
		method: 'post',
		data: data,
	}, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
/**
 * AI大纲
 * @param {*} data.funFataId
 * @param {*} data.systemTitle
 * @param {*} data.content
 * @param {*} data.type pc
 * @param {*} data.chat_list_id pc
 * @param {*} data.userFileId pc
 * @returns
 */
export const getSessionMsg = (data) => {
	return request({
    baseURL,
		url: `/api/mjkj-chat/chat/ai/session/getMsg`,
		method: 'post',
		data,
	})
}

/**
 * 删除或者收藏课程
 * @param {*} data.courseId
 * @param {*} data.type 1:恢复 2:收藏 3:删除
 * @returns
 */
export const updateCourseType = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/updateType`,
		method: 'post',
		data,
	})
}
/**
 * 修改课程名称
 * @param {*} data.courseId
 * @param {*} data.name
 * @returns
 */
export const updateCourseName = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/edit`,
		method: 'post',
		data,
	})
}
/**
 * 视频合成保存编辑内容
 * @param {*} data.courseId
 * @param {*} data.outlineId
 * @param {*} data.content // json字符串
 * @returns
 */
export const videoEditSave = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/video/edit`,
		method: 'post',
		data,
	})
}
/**
 * 视频合成保存编辑内容获取
 * @param {*} data.outlineId
 * @returns
 */
export const getEditVideoContent = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/video/getEditContent`,
		method: 'post',
		data,
	})
}
/**
 * 视频合成的预计时长
 * @param {*} data.notes
 * @returns
 */
export const getVideoDuration = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/video/duration`,
		method: 'post',
		data,
	})
}

/**
 * 创建试卷名称
 * @param {*} data.name
 * @param {*} data.courseId
 * @returns
 */
export const createQuestionName = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/question/create/name`,
		method: 'post',
		data,
	})
}
/**
 * 获取试卷列表
 * @param {*} data.courseId
 * @returns
 */
export const getQuestionList = (data) => {
	return request({
    baseURL,
		url: `/api/AiCourse/course/question/list`,
		method: 'post',
		data,
	})
}
